// Import of creatApp from Vue 3 bundler.
import { createApp } from 'vue/dist/vue.esm-bundler.js';

// Functions imports.
import { clickOutside } from './functions.js';

// App imports.
import newsApp from './vue/news.js';
import agendaApp from './vue/agenda.js';
import agendaDetailApp from './vue/agendaDetail.js';

document.addEventListener('DOMContentLoaded', () => {
   
    const newsOverviewContainer = document.getElementById('news-overview');

    if (newsOverviewContainer) {
        createApp(newsApp).mount(newsOverviewContainer);
    }

    const newsWidgetContainers = document.querySelectorAll('.widget-news');

    newsWidgetContainers.forEach(container => {
        createApp(newsApp).mount(container);
    });

    const agendaOverviewContainer = document.getElementById('agenda-overview');

    if (agendaOverviewContainer) {
        createApp(agendaApp).directive('click-outside', clickOutside).mount(agendaOverviewContainer);
    }

    const upcomingWidgetContainers = document.querySelectorAll('.widget-upcoming');

    upcomingWidgetContainers.forEach(upcomingContainer => {
        createApp(agendaApp).mount(upcomingContainer);
    });

    const tipContainers = document.querySelectorAll('.widget-tips');

    tipContainers.forEach(tipContainer => {
        createApp(agendaApp).mount(tipContainer);
    });

    const agendaDetailContainer = document.getElementById('agenda-detail');

    if (agendaDetailContainer) {
        createApp(agendaDetailApp).mount(agendaDetailContainer);
    }
});
